import { types } from "../types/types"

const initialState = {
    modalOpenOrdersOrDeliverys: false,
    modalData: null
}

export const uiOrdersOrDeliverysReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.uiOpenModalOrdersOrDeliverys:
            return {
                ...state,
                modalOpenOrdersOrDeliverys: true,
                modalData: action.payload
            }

        case types.uiCloseModalOrdersOrDeliverys:
            return {
                ...state,
                modalOpenOrdersOrDeliverys: false,
                modalData: null
            }

        default:
            return state;
    }
}